import React from 'react';
import { Modal } from '../_components';
import { useModal } from '../_contexts';
import { TimelineListForm } from './forms';
import { useSelector } from 'react-redux';

export function TimelineManager() {
  const { closeModal } = useModal();
  const { items: timelines } = useSelector((state) => state.timelines);

  return (
    <Modal
      id="timelineManagerModal"
      // backdrop
      title="Timelines Manager"
      icon="fas fa-stream"
      size="md"
      open={true}
      onClose={() => closeModal()}
    >
      {timelines && <TimelineListForm timelines={timelines} />}
    </Modal>
  );
}
